/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 18.5V20C6 20.5304 6.21071 21.0391 6.58578 21.4142C6.96086 21.7893 7.46957 22 8 22H16.5C17.0304 22 17.5391 21.7893 17.9142 21.4142C18.2893 21.0391 18.5 20.5304 18.5 20V18.5H6ZM16.5 20.5H8V20H16.5V20.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 2H8C7.46957 2 6.96086 2.21072 6.58578 2.58579C6.21071 2.96087 6 3.46957 6 4V17.5H18.5V4C18.5 3.46957 18.2893 2.96087 17.9142 2.58579C17.5391 2.21072 17.0304 2 16.5 2ZM11 14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5H9C8.73478 15.5 8.48043 15.3946 8.29289 15.2071C8.10536 15.0196 8 14.7652 8 14.5V4H11V14.5Z",
  fill: "currentColor"
})), 'CategoryPI');